/**
 * https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking/
 *
 * Created by andrey on 21.05.2025
 */

import CleverAppsNative from "./cleverappsnative";
import Utils from "./utils";

const pixelId = "558106843723417";

const FacebookPixel = {
    logEvent: function (options) {
        fbq("trackCustom", options.name, options.params);
    },

    logPurchase: function (options) {
        fbq("track", "Purchase", {
            currency: options.currency,
            value: options.value
        });
    },

    logAdRevenue: function (options) {
        fbq("trackCustom", "ad_revenue", {
            value: options.value,
            currency: options.currency,
            ad_format: options.ad_format,
            ad_placement: options.ad_placement
        });
    }
};

export default {
    install: function () {
        CleverAppsNative.addPlugin("FacebookPixel", FacebookPixel);

        Utils.loadSdk("//connect.facebook.net/en_US/fbevents.js", {
            crossorigin: false,
            onSuccess: function () {
                console.log("FacebookPixel loaded");
            }
        });

        if (!window.fbq) {
            const n = window.fbq = function () {
                // eslint-disable-next-line
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!window._fbq) {
                window._fbq = n;
            }
            n.push = n;
            n.loaded = !0;
            n.version = "2.0";
            n.queue = [];
        }

        fbq("init", pixelId);
        fbq("track", "PageView");
    }
};